import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  itemFindByOption,
  createItem,
  getById,
  updateById,
  getTenantItemsCount,
  downloadItemTemplate,
  bulkItemImport,
  getBulkReport,
  getItemDetailsById,
  offlineItem,
  listDriver
} from "../../services/item.js";

@Module({
  namespaced: true
})
export default class Item extends VuexModule {
  // state

  public currentSearchCatalogId = "";
  public itemList = [];
  public currentReadItem = {};
  public currentItemLocationObject = {};
  public bulkReportList = [];
  public itemDetailsById = {};
  public driverList = [];

  // actions

  @Action
  public async fetchDriverList() {
    try {
      const data = await listDriver();
      this.context.commit("setDriverList", data.data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async fetchItemsByCatalog(payload) {
    try {
      const data = await itemFindByOption(payload);
      this.context.commit("setItemList", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchItemDetailsById(payload) {
    try {
      const data = await getItemDetailsById(payload);
      this.context.commit("setItemDetailsById", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async createItem(payload) {
    try {
      const data = await createItem(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async downloadItemTemplate(payload) {
    try {
      const data = await downloadItemTemplate(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async bulkItemImport(payload) {
    try {
      const data = await bulkItemImport(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getBulkReport(payload) {
    try {
      const response = await getBulkReport(payload);
      this.context.commit("setBulkReport", response.data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchItemById(payload) {
    try {
      const data = await getById(payload);
      this.context.commit("setCurrentReadItem", data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updateItemById(payload) {
    try {
      const data = await updateById(payload.id, payload.object);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async setItemCatalogLocation(payload) {
    try {
      this.context.commit("setCatalogLocation", payload);
      return payload;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchTenantsItemCount() {
    try {
      const data = await getTenantItemsCount();
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async offlineItem(payload) {
    try {
      const data = await offlineItem(payload.data);
      return data;
    } catch (error) {
      throw error;
    }
  }
  // mutations

  @Mutation
  public setDriverList(data: any) {
    this.driverList = data;
  }

  @Mutation
  public setItemList(data: any) {
    this.itemList = data;
  }

  @Mutation
  public setItemDetailsById(data: any) {
    this.itemDetailsById = data;
  }

  @Mutation
  public setCurrentReadItem(data: any) {
    this.currentReadItem = data;
  }

  @Mutation
  public setCatalogLocation(data: any) {
    this.currentItemLocationObject = data;
  }

  @Mutation
  public setBulkReport(data) {
    this.bulkReportList = data;
  }

  // getters
  get GetDriverList() {
    return this.driverList;
  }

  get GetItemListByCatalog() {
    return this.itemList;
  }

  get GetCurrentItemObject() {
    return this.currentReadItem;
  }

  get GetCurrentCatalogLocation() {
    return this.currentItemLocationObject;
  }

  get GetBulkItemReport() {
    return this.bulkReportList;
  }

  get GetItemDetailsById() {
    return this.itemDetailsById;
  }
}
